var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 20px;\n  "], ["\n    margin-bottom: 20px;\n  "])));
});
export var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 93px;\n  width: 93px;\n  flex-shrink: 0;\n  margin-right: 25px;\n"], ["\n  height: 93px;\n  width: 93px;\n  flex-shrink: 0;\n  margin-right: 25px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
